
import { useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useSession } from "@/hooks/useSession";

export function useQuizAttemptChecker() {
  const { session } = useSession();

  const checkLinkingAttempt = useCallback(async (fileId: string) => {
    if (!session?.user?.id) return false;
    
    try {
      const { data: linkingAttempt, error: linkingError } = await supabase
        .from('linking_attempts')
        .select('passed')
        .eq('file_id', fileId)
        .eq('trainee_id', session.user.id)
        .eq('passed', true)
        .maybeSingle();
        
      if (linkingError) {
        console.log("Error checking linking attempts:", linkingError);
        return false;
      }
      
      return !!linkingAttempt?.passed;
    } catch (error) {
      console.error("Error in checkLinkingAttempt:", error);
      return false;
    }
  }, [session?.user?.id]);

  const checkQuizAttempt = useCallback(async (fileId: string) => {
    if (!session?.user?.id) return false;
    
    try {
      // Check for quiz file
      const { data: fileData } = await supabase
        .from('resource_files')
        .select('quiz_id')
        .eq('id', fileId)
        .maybeSingle();
        
      if (!fileData?.quiz_id) return false;
      
      // Check for passed quiz attempts
      const { data: quizAttempt, error: quizError } = await supabase
        .from('quiz_attempts')
        .select('passed')
        .eq('quiz_id', fileData.quiz_id)
        .eq('trainee_id', session.user.id)
        .eq('passed', true)
        .maybeSingle();
        
      if (quizError) {
        console.log("Error checking quiz attempts:", quizError);
        return false;
      }
      
      return !!quizAttempt?.passed;
    } catch (error) {
      console.error("Error in checkQuizAttempt:", error);
      return false;
    }
  }, [session?.user?.id]);

  return {
    checkLinkingAttempt,
    checkQuizAttempt
  };
}
